module.exports = __webpack_public_path__ + "media/icons/heart-f8eac338.svg";